import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { fontFamily } from 'html2canvas/dist/types/css/property-descriptors/font-family';

@Injectable({
   providedIn: 'root',
})
export class AssignmentService {
   constructor(private http: HttpClient) { }

   createAssignment(data) {
      let subjectId = data.subject;
      let name = data.name;
      let startDate = new Date(data.startDate);
      let endDate = new Date(data.endDate);
      let lateSubmissions = data.lateSubmissionsDate;
      let numberOfReSubmisions = data.nrReSubmissions;
      let descriptions = data.description;
      let type = parseInt(data.type);
      let id = data.id;
      let originalLanguage = data.originalLanguage;
      let translatedLanguage = data.translatedLanguage;

      let source_percentage_threshold = data.source_percentage_threshold;
      let submission_word_limit = data.submission_word_limit;
      let exclude_citations = data.exclude_citations;
      let anonymous_submissions = data.anonymous_submissions;

      let sources = {
         excludeSources: data.sources.excludeSources,
         includeSources: data.sources.includeSources
      };

      let sentence_thresholds = {
         exactMatchThreshold: data.exactMatchThreshold,
         alteredTextThreshold: data.alteredTextThreshold,
         contextualSimilaritiesThreshold: data.contextualSimilaritiesThreshold
      };

      let context_similarity = data.contextualSimilarity;

      if (!numberOfReSubmisions) {
         numberOfReSubmisions = 0;
      }

      if (!lateSubmissions) {
         lateSubmissions = null;
      } else {
         lateSubmissions = new Date(data.lateSubmissionsDate);
      }

      let assignmentType = data.assignmentType;
      let fileType = data.fileType;
      let fontFamily = data.fontFamily

      return this.http
         .post<any>(`${environment.apiUrl}/assignment`, {
            subjectId,
            name,
            startDate,
            endDate,
            lateSubmissions,
            numberOfReSubmisions,
            descriptions,
            type,
            assignmentId: id,
            originalLanguage,
            translatedLanguage,
            aiDetectionEnabled: data.aiDetection,
            archive: data.archive,
            source_percentage_threshold,
            submission_word_limit,
            exclude_citations,
            anonymous_submissions,
            sources,
            sentence_thresholds,
            context_similarity,
            assignmentType,
            fileType,
            fontFamily,
            metadataAnalysis: data.metadataAnalysis
         })
         .pipe(
            map((data) => {
               console.log('Service response: ', data);
               return data;
            })
         );
   }

   getAssignments(userId, name, subjectId, type, page, limit?: number) {
      return this.http
         .get<any>(
            `${environment.apiUrl}/assignments/?page=${page}` +
            (limit !== undefined ? `&limit=${limit}` : '') +
            (subjectId ? `&subjectId=${subjectId}` : '') +
            (type ? `&type=${type}` : '') +
            (name ? `&name=${name}` : '')
         )
         .pipe(
            map((data) => {
               return data;
            })
         );
   }

   editAssignment(data, id) {
      let subjectId = data.subject;
      let name = data.name;
      let startDate = new Date(data.startDate);
      let endDate = new Date(data.endDate);
      let lateSubmissions = data.lateSubmissionsDate;
      let numberOfReSubmisions = data.nrReSubmissions;
      let descriptions = data.description;
      let type = parseInt(data.type);
      let originalLanguage = data.originalLanguage;
      let translatedLanguage = data.translatedLanguage;

      let source_percentage_threshold = data.source_percentage_threshold;
      let submission_word_limit = data.submission_word_limit;
      let exclude_citations = data.exclude_citations;
      let anonymous_submissions = data.anonymous_submissions;

      let sources = {
         excludeSources: data.sources.excludeSources,
         includeSources: data.sources.includeSources
      };

      let sentence_thresholds = {
         exactMatchThreshold: data.exactMatchThreshold,
         alteredTextThreshold: data.alteredTextThreshold,
         contextualSimilaritiesThreshold: data.contextualSimilaritiesThreshold
      };

      console.log(sentence_thresholds, "sentence_thresholds");


      let context_similarity = data.contextualSimilarity;

      if (!numberOfReSubmisions) {
         numberOfReSubmisions = 0;
      }

      if (!lateSubmissions) {
         lateSubmissions = null;
      } else {
         lateSubmissions = new Date(data.lateSubmissionsDate);
      }

      let assignmentType = data.assignmentType;
      let fileType = data.fileType;
      let fontFamily = data.fontFamily

      return this.http
         .put<any>(`${environment.apiUrl}/assignment/${id}`, {
            subjectId,
            name,
            startDate,
            endDate,
            lateSubmissions,
            numberOfReSubmisions,
            descriptions,
            type,
            assignmentId: id,
            originalLanguage,
            translatedLanguage,
            aiDetectionEnabled: data.aiDetection,
            archive: data.archive,
            source_percentage_threshold,
            submission_word_limit,
            exclude_citations,
            anonymous_submissions,
            sources,
            sentence_thresholds,
            context_similarity,
            assignmentType,
            fileType,
            fontFamily,
            metadataAnalysis: data.metadataAnalysis
         })
         .pipe(
            map((data) => {
               return data;
            })
         );
   }

   updateAssignmentCheckStatus(assignmentId: string) {
      return this.http
         .post<any>(`${environment.apiUrl}/assignment/${assignmentId}/update-check-status`, {})
         .pipe(
            map((response) => {
               return response;
            })
         );
   }

   deleteAssignment(id) {
      return this.http
         .delete<any>(`${environment.apiUrl}/assignment/${id}`, {})
         .pipe(
            map((data) => {
               return data;
            })
         );
   }

   getAssignment(id) {
      return this.http
         .get<any>(`${environment.apiUrl}/assignment/${id}`)
         .pipe(
            map((data) => {
               return data;
            })
         );
   }

   startStartCodeCheck(assignmentId: string) {
      return this.http.post<any>(`${environment.apiUrl}/assignment/${assignmentId}/code-check`, {})
         .pipe(
            map((response) => {
               return response;
            })
         );
   }

   getCodePresignedUrl(assignmentId: string, userName: string, fileName: string) {
      const tempUserName = userName.split(' ').join('_');
      const tempFileName = fileName.split(' ').join('_');
      const keyFileName = `${tempUserName}__${tempFileName}_summary.zip`
      return this.http.get<any>(`${environment.apiUrl}/assignment/${assignmentId}/code-presigned-url?fileKey=${keyFileName}&assignmentId=${assignmentId}`)
         .pipe(
            map((response) => {
               return response;
            })
         );
   }
}
